// tutorial: questo è l'entry point dell'applicazione, qui registriamo i plugins di Vue
// e istanziamo il componente di root
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { EventBusPlugin } from './events/bus';
import VeeValidate from 'vee-validate';
import FiltersPlugin from './filters';
import validationIniter from './commons/validation';
import { sync } from 'vuex-router-sync';
import VueTagManager from 'vue-tag-manager';
import { i18n } from './i18n/index';
import { err, success } from './commons/toast';

Vue.config.productionTip = false;
Vue.config.ignoredElements = [
  'klarna-placement',
];

Vue.use(EventBusPlugin);

Vue.use({
  install(vm: any) {
    vm.prototype.$toast = { err, success };
  },
});
Vue.use(FiltersPlugin);
if (store.state.options.gtm && store.state.options.gtm.gtmId) {
  Vue.use(VueTagManager, store.state.options.gtm);
}

Vue.use(VeeValidate, validationIniter(i18n));

sync(store, router);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
